// Walks a Storyblok richtext document/node down to its plain-text content.
// Node shape is `{ text }` for leaves and `{ content: [...] }` for
// containers; `content` itself may also just be a plain string.
export const getRichTextPlainText = node => {
  if (!node) {
    return '';
  }

  if (typeof node === 'string') {
    return node;
  }

  if (typeof node.text === 'string') {
    return node.text;
  }

  if (Array.isArray(node.content)) {
    return node.content.map(getRichTextPlainText).join('');
  }

  return '';
};
